import script from "./KalkulatorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./KalkulatorView.vue?vue&type=script&setup=true&lang=ts"

import "./KalkulatorView.vue?vue&type=style&index=0&id=6d46388a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d46388a"]])

export default __exports__